import { useState, useEffect } from 'react';
import { Tooltip, Switch, Select, Radio } from 'antd';
import FormField from 'components/FormField';
import { noop } from 'lodash-es';
import { useFormikContext } from 'formik';
import { PolicyFormValues, Question } from './share';
import { DisabledProps } from '../TaskForm/share';
import { T, useTranslate } from '@tolgee/react';

type FV = Pick<PolicyFormValues, 'cancelTradeConfig'>;

export const validate = noop;

const canSelHours = [
  ...[0.25, 0.5, 1, 2, 4, 6, 8, 12],
  ...Array(10)
    .fill(1)
    .map((_, i) => (i + 1) * 24),
];

function AutoCancelField({ disabled }: DisabledProps) {
  const {
    values: { cancelTradeConfig },
  } = useFormikContext<FV>();

  const { t } = useTranslate();

  const [timeType, setTimeType] = useState(1);

  useEffect(() => {
    setTimeType(cancelTradeConfig?.autoCancelLimitHour ? 2 : 1);
  }, [cancelTradeConfig?.autoCancelLimitHour]);

  return (
    <>
      <FormField<Required<FV>['cancelTradeConfig']['autoCancel']>
        required
        name="cancelTradeConfig.autoCancel"
        label={
          <div>
            {t('aide.自动同意取消订单申请')}
            <Tooltip title={t('aide.自动同意取消订单申请的说明')}>
              <Question />
            </Tooltip>
          </div>
        }
        style={{ marginBottom: '8px' }}
      >
        {({ field: { value = false, onChange } }) => {
          return (
            <Switch
              disabled={disabled}
              checked={value}
              onChange={onChange}
              checkedChildren={t('aide.开')}
              unCheckedChildren={t('aide.关')}
            />
          );
        }}
      </FormField>
      {cancelTradeConfig?.autoCancel ? (
        <FormField<Required<FV>['cancelTradeConfig']['autoCancelLimitHour']>
          required
          name="cancelTradeConfig.autoCancelLimitHour"
        >
          {({ field: { value, onChange } }) => {
            return (
              <div style={{ padding: '12px 20px', background: '#F7F9FA' }}>
                <Radio.Group
                  disabled={disabled}
                  value={timeType}
                  onChange={(e) => {
                    setTimeType(e.target.value);
                    if (e.target.value === 1) {
                      onChange(0);
                    } else {
                      onChange(1);
                    }
                  }}
                >
                  <Radio style={{ marginRight: '36px' }} value={1}>
                    {t('aide.任意时间')}
                  </Radio>
                  <Radio value={2}>{t('aide.指定时间内')}</Radio>
                </Radio.Group>
                <div style={{ marginTop: '8px' }}>
                  {timeType === 2 ? (
                    <T
                      keyName="aide.自动同意取消指定时间"
                      params={{
                        cancelledMsg: t('aide.买家提交的取消订单申请已通过'),
                        incancelMsg: t('aide.买家提交的取消订单申请，待卖家处理'),
                        x: (
                          <Select
                            disabled={disabled}
                            size="middle"
                            defaultValue={!value ? 1 : value}
                            style={{ width: 140, margin: '0 4px' }}
                            onChange={(v) => onChange(Number(v))}
                            options={canSelHours.map((v) => ({
                              value: v,
                              label:
                                v < 1
                                  ? `≤${Math.round(v * 60)}${t('translation.分钟')}`
                                  : v < 24
                                  ? `≤${v}${t('translation.小时')}`
                                  : `≤${v}${t('translation.小时')}(${v / 24}${t(
                                      'translation.天',
                                    )})`,
                            }))}
                          />
                        ),
                      }}
                    />
                  ) : (
                    t('aide.自动同意取消任意时间', {
                      cancelledMsg: t('aide.买家提交的取消订单申请已通过'),
                    })
                  )}
                </div>
              </div>
            );
          }}
        </FormField>
      ) : null}
    </>
  );
}

export default AutoCancelField;
